"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WithClerk = exports.withClerk = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const IsomorphicClerkContext_1 = require("../contexts/IsomorphicClerkContext");
const StructureContext_1 = require("../contexts/StructureContext");
const errors_1 = require("../errors");
const withClerk = (Component, displayName) => {
    displayName = displayName || Component.displayName || Component.name || 'Component';
    Component.displayName = displayName;
    const HOC = (props) => {
        const clerk = (0, IsomorphicClerkContext_1.useIsomorphicClerkContext)();
        if (!clerk.loaded) {
            return null;
        }
        return (react_1.default.createElement(StructureContext_1.LoadedGuarantee, null,
            react_1.default.createElement(Component, Object.assign({}, props, { clerk: clerk }))));
    };
    HOC.displayName = `withClerk(${displayName})`;
    return HOC;
};
exports.withClerk = withClerk;
const WithClerk = ({ children }) => {
    const clerk = (0, IsomorphicClerkContext_1.useIsomorphicClerkContext)();
    if (typeof children !== 'function') {
        throw new Error(errors_1.hocChildrenNotAFunctionError);
    }
    if (!clerk.loaded) {
        return null;
    }
    return react_1.default.createElement(StructureContext_1.LoadedGuarantee, null, children(clerk));
};
exports.WithClerk = WithClerk;
